import React from 'react';

const label = key => key.replace(/_/g, ' ').replace(/^./, letter => letter.toUpperCase());

function Details({ value }) {
  if (value == null) return <span>—</span>;
  if (Array.isArray(value)) return value.length
    ? <ul className="space-y-2">{value.map((item, index) => <li key={index}><Details value={item} /></li>)}</ul>
    : <span>None</span>;
  if (typeof value === 'object') return (
    <dl className="space-y-1 border-l pl-3">
      {Object.entries(value).map(([key, item]) => (
        <div key={key}><dt className="font-medium">{label(key)}</dt><dd className="break-words"><Details value={item} /></dd></div>
      ))}
    </dl>
  );
  return <span>{String(value)}</span>;
}

export default function ScanFindingsSummary({ notification }) {
  const findings = (notification.findings || []).filter(result => result.resistance_levels?.length || result.support_levels?.length || result.signals?.length);
  return (
    <div className="mt-3 max-h-80 space-y-3 overflow-y-auto text-sm text-gray-700">
      <p>{notification.source === 'automatic' ? `Auto Scanner: ${notification.name}` : 'Manual scanner'}</p>
      <p>{findings.reduce((total, result) => total + (result.resistance_levels?.length || 0), 0)} resistance levels found · {findings.reduce((total, result) => total + (result.support_levels?.length || 0), 0)} support levels found</p>
      {findings.map((result, index) => (
        <details key={`${result.symbol}-${index}`} className="rounded border p-2">
          <summary className="cursor-pointer font-semibold">{result.symbol} · {result.resistance_levels?.length || 0} resistance · {result.support_levels?.length || 0} support · {result.signals?.length || 0} signals</summary>
          <Details value={result} />
        </details>
      ))}
      {notification.errors?.length > 0 && <Details value={{ errors: notification.errors }} />}
      {notification.deferred > 0 && <p>{notification.deferred} symbols deferred</p>}
    </div>
  );
}
